import { GetTipoPromotoreQuery } from '../../_graphql/generated';

export type TipoPromotoreState = {
  loading: boolean;
  lista: GetTipoPromotoreQuery['anagrafica_tipo_promotore'];
  failure: any;
};

export const initialTipoPromotoreState: TipoPromotoreState = {
  loading: false,
  lista: [],
  failure: '',
};
